import { useSettings } from "@/providers/general/settings-provider";

import { ChatbotWidget } from "./chatbot-widget";

export function DarwinAI() {
    const { currentSettings } = useSettings();

    if (!currentSettings.DARWIN_AI_ENABLED) return null;

    return <ChatbotWidget />;
}
